/* eslint-disable react/prop-types */
import React from 'react';
import Certifications from './certifications';
import Specialties from './specialties/index';
import SubSpecialties, { type SubSpecialty } from './sub_specialties/index';
import Organizations from './organizations';
import Departments, { type Department } from './departments/index';
import Regions, { type Region } from './regions';

export interface BrokerTitlesProps {
  certifications: any;
  departments: Department[];
  groupSpecialties: boolean;
  organizations: any;
  regions: Region[],
  showDepartments?: boolean;
  showRegions?: boolean;
  specialties: any;
  specialtyPropertyTypes: any;
  subSpecialties: SubSpecialty[];
}

export default function BrokerTitles({
  certifications,
  departments,
  groupSpecialties,
  organizations,
  regions,
  showDepartments,
  showRegions,
  specialties,
  specialtyPropertyTypes,
  subSpecialties
}: BrokerTitlesProps) {
  return (
    <>
      <Certifications certifications={certifications}/>
      <Specialties
        groupSpecialties={groupSpecialties}
        specialties={specialties}
        specialtyPropertyTypes={specialtyPropertyTypes}
      />
      <SubSpecialties subSpecialties={subSpecialties}/>
      <Organizations organizations={organizations}/>
      {showDepartments && <Departments departments={departments}/>}
      {showRegions && <Regions regions={regions}/>}
    </>
  );
}
